import { createFileRoute } from "@tanstack/react-router";
import { LocalLandingPage } from "@/components/landing/LocalLandingPage";
import { madridLandings } from "@/data/madrid-landings";
import { buildLocalLandingHead } from "@/lib/local-landing-seo";

const data = madridLandings["agencia-seo-madrid"]!;

export const Route = createFileRoute("/agencia-seo-madrid")({
  head: () => buildLocalLandingHead(data),
  component: () => <LocalLandingPage data={data} />,
});
